import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import {
  QUEUE_SYMBOLS,
  ROLE_SYMBOL_TO_STR,
} from "@/game-lol/constants/constants.mjs";
import * as GraphQLTemplatesDatalake from "@/game-lol/graphql-templates-datalake.mjs";
import PlaystyleBuilds from "@/game-lol/models/lol-champion-builds.mjs";
import { getQueueDetails } from "@/game-lol/utils/symbol-queue.mjs";
import RoleSymbol from "@/game-lol/utils/symbol-role.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

function getChampionBuilds(
  variables: {
    championId: string;
    queue: string;
    role?: string;
    opponentChampionId?: string;
    tier?: string;
  } = {
    championId: "",
    queue: "",
    role: "",
    opponentChampionId: "",
    tier: "",
  },
) {
  const championId = `${variables.championId}`;
  const queue = variables.queue
    ? getQueueDetails(variables.queue)?.gql
    : getQueueDetails(QUEUE_SYMBOLS.rankedSoloDuo).gql;

  const params: {
    championId: string;
    queue: string;
    role?: string;
    matchupChampionId?: string;
    tier?: string;
  } = {
    championId,
    queue,
  };

  if (variables.role)
    params.role = ROLE_SYMBOL_TO_STR[RoleSymbol(variables.role)]?.gql;
  if (variables.opponentChampionId)
    params.matchupChampionId = `${variables.opponentChampionId}`;
  if (variables.tier) params.tier = variables.tier;

  return queryGQL(
    appURLs.DATALAKE,
    GraphQLTemplatesDatalake.ChampionBuildsTagged,
    params,
  );
}

export default function ({ params, path, options = {} }) {
  return getData(getChampionBuilds(params), PlaystyleBuilds, path, options);
}
